import React from 'react';
import './AnalyticsPostPreviewCard.css';

import likeIconRed from '../assets/like-icon-red.png';
import commentIcon from '../assets/comment-icon.png';
import shareIcon from '../assets/share-icon.png';
import saveIconFilled from '../assets/save-icon-filled.png';
import repostIcon from '../assets/repost-icon.png';
import tipIcon from '../assets/tip-icon.png';

function safeNum(n) {
  const x = Number(n);
  return Number.isFinite(x) ? x : 0;
}

function fmtPi(n) {
  const x = Number(n);
  if (!Number.isFinite(x)) return '0';
  return x.toFixed(6).replace(/\.?0+$/, '');
}

function shortText(s, n = 90) {
  const t = (s || '').toString().replace(/\s+/g, ' ').trim();
  if (!t) return '';
  return t.length > n ? t.slice(0, n - 1) + '…' : t;
}

/* 🔎 classify media quickly */
const classifyMediaUrl = (url = '') => {
  const u = String(url).toLowerCase().split('?')[0];
  if (u.endsWith('.mp4') || u.endsWith('.webm') || u.endsWith('.mov')) return 'video';
  if (u.match(/\.(jpg|jpeg|png|gif|webp)$/)) return 'image';
  if (u.includes('/videos/')) return 'video';
  return 'image';
};

/* 🖼 best preview logic (image > thumbnail) */
function getPreviewImage(post) {
  if (!post) return null;

  if (typeof post.mediaPreview === 'string' && post.mediaPreview.length > 5) {
    return post.mediaPreview;
  }

  const raw =
    Array.isArray(post.media) ? post.media :
    post.media ? [post.media] :
    [];

  const rawItems = Array.isArray(post.mediaItems) ? post.mediaItems : [];

  const norm = [];

  for (const m of raw) {
    if (!m) continue;
    if (typeof m === 'string') {
      norm.push({ url: m, type: classifyMediaUrl(m) });
    } else if (typeof m === 'object' && m.url) {
      norm.push({ url: m.url, type: classifyMediaUrl(m.url) });
    }
  }

  for (const it of rawItems) {
    if (!it || typeof it.url !== 'string') continue;
    const t = it.type ? String(it.type).toLowerCase() : classifyMediaUrl(it.url);
    norm.push({ url: it.url, type: t });
  }

  // 1️⃣ First image
  const firstImage = norm.find((x) => x.type === 'image' && x.url);
  if (firstImage) return firstImage.url;

  // 2️⃣ Video-only → thumbnail
  const hasVideo = norm.some((x) => x.type === 'video');
  if (hasVideo && typeof post.thumbnail === 'string' && post.thumbnail.length > 5) {
    return post.thumbnail;
  }

  return null;
}

export default function AnalyticsPostPreviewCard({ post, onClick }) {
  if (!post) return null;

  const likes = safeNum(post.likes);
  const comments = safeNum(post.comments);
  const shares = safeNum(post.shares);
  const saves = safeNum(post.saves);
  const tipsCount = safeNum(post.tipsCount);
  const tipsTotalPi = safeNum(post.tipsTotalPi);

  const caption = shortText(post.content, 95);
  const previewImg = getPreviewImage(post);

  const handleKeyDown = (e) => {
    if (!onClick) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <div
      className="aprev-card"
      onClick={onClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
    >
      {/* Media */}
      <div className="aprev-media">
        {previewImg ? (
          <img
            src={previewImg}
            alt=""
            className="aprev-media-img"
            loading="lazy"
          />
        ) : (
          <div className="aprev-media-ph">See post</div>
        )}
      </div>

      {/* Body */}
      <div className="aprev-body">
        <div className={`aprev-caption ${caption ? '' : 'muted'}`}>
          {caption || 'No text'}
        </div>

        {/* Actions */}
        <div className="aprev-actions">
          <div className="aprev-act">
            <img src={likeIconRed} alt="" className="aprev-icon" />
            <span className="aprev-count">{likes}</span>
          </div>

          <div className="aprev-act">
            <img src={commentIcon} alt="" className="aprev-icon" />
            <span className="aprev-count">{comments}</span>
          </div>

          <div className="aprev-act">
            <img src={tipIcon} alt="" className="aprev-icon" />
            <span className="aprev-count">{tipsCount}</span>
          </div>

          <div className="aprev-act">
            <img src={repostIcon} alt="" className="aprev-icon" />
            <span className="aprev-count">{shares}</span>
          </div>

          <div className="aprev-act">
            <img src={saveIconFilled} alt="" className="aprev-icon" />
            <span className="aprev-count">{saves}</span>
          </div>
        </div>

        <div className="aprev-tipsTotal">
          Tips: <b>{fmtPi(tipsTotalPi)} Pi</b>
        </div>
      </div>
    </div>
  );
}
